import {
  IWorkflowTemplateListResponse,
  TGetWorkflowTemplateListParams,
} from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { BASE_URL } from './helpers';

/** `null` disables the fetch entirely (for callers whose inputs aren't ready yet); `undefined`
 * keeps today's behavior of fetching the unfiltered list. */
export const useWorkflowTemplates = (
  queryParams?: TGetWorkflowTemplateListParams | null
) => {
  const query = new URLSearchParams();
  if (queryParams?.name) query.append('name', queryParams.name);
  if (queryParams?.createdByUserId)
    query.append('createdByUserId', queryParams.createdByUserId);
  if (queryParams?.companyId)
    query.append('companyId', queryParams.companyId.toString());
  if (queryParams?.extends)
    queryParams.extends.forEach((option) => query.append('extends', option));

  const url =
    queryParams === null ? null : `${BASE_URL}/list?${query.toString()}`;

  const { data, error, isLoading, mutate } =
    useSWR<IWorkflowTemplateListResponse>(
      url,
      SWRFetcher({
        method: 'GET',
      })
    );

  return { data, error, isLoading, mutate };
};
